"use client";

import React, { useRef, useState } from "react";

const faqs = [
	{
		question: "Unde pot livra comanda mea?",
		answer: "Livrăm în toată Romania. Comenzile sunt procesate rapid și livrate în intervalul de timp estimat afișat la finalizarea comenzii.",
	},
	{
		question: "Cum pot returna un produs?",
		answer: "Poți iniția o returnare în termen de 14 zile de la primirea coletului. Contactează-ne prin formularul de retur sau pe email și îți vom trimite instrucțiunile complete.",
	},
	{
		question: "Cum îmi pot vizualiza detaliile comenzii sau factura?",
		answer: "Accesează contul tău și navighează la secțiunea 'Comenzile mele'. De acolo poți descărca factura și urmări statusul comenzii.",
	},
	{
		question: "Voi primi exact produsul din poze?",
		answer: "Da! Ne asigurăm că fotografiile reflectă fidel produsele reale. Culorile pot varia ușor în funcție de setările monitorului tău.",
	},
];

export default function ContactPage() {
	const formRef = useRef();
	const [success, setSuccess] = useState(null);
	const [showMessage, setShowMessage] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");
	const [compliance, setCompliance] = useState(false);
	const [openFaq, setOpenFaq] = useState(0);

	const handleShowMessage = (message = "") => {
		setErrorMessage(message);
		setShowMessage(true);
		setTimeout(() => {
			setShowMessage(false);
			setErrorMessage("");
		}, 4000);
	};

	const sendMail = async (e) => {
		e.preventDefault();

		if (!compliance) {
			handleShowMessage("Te rugăm să accepți prelucrarea datelor personale.");
			setSuccess(false);
			return;
		}

		setIsSubmitting(true);

		try {
			const formData = new FormData(formRef.current);
			const data = {
				name: formData.get("name")?.trim(),
				email: formData.get("email")?.trim(),
				message: formData.get("message")?.trim(),
			};

			if (!data.name || !data.email || !data.message) {
				handleShowMessage("Toate câmpurile sunt obligatorii");
				setSuccess(false);
				setIsSubmitting(false);
				return;
			}

			const response = await fetch("/api/contact", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(data),
			});

			const result = await response.json();

			if (response.ok) {
				setSuccess(true);
				formRef.current.reset();
				setCompliance(false);
				handleShowMessage("");
			} else {
				setSuccess(false);
				handleShowMessage(result.error || "A apărut o eroare");
			}
		} catch (error) {
			console.error("Error:", error);
			setSuccess(false);
			handleShowMessage("Eroare de conexiune. Te rugăm să reîncerci.");
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<>
			<style>{`

        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

        .cp-root {

          min-height: 100vh;
          padding: 80px 24px;
          color: #1a1a1a;
        }

        .cp-inner {
          max-width: 1160px;
          margin: 0 auto;
        }

        .cp-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 80px;
          align-items: start;
        }

        @media (max-width: 860px) {
          .cp-grid { grid-template-columns: 1fr; gap: 60px; }
        }

        /* ── FAQ ── */
        .cp-section-title {
          font-family: 'Fraunces', serif;
          font-size: 2rem;
          font-weight: 600;
          letter-spacing: -0.02em;
          color: #111;
          margin-bottom: 32px;
          line-height: 1.2;
        }

        .faq-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .faq-item {
          background: #fff;
          border: 1px solid #e8e4df;
          border-radius: 14px;
          overflow: hidden;
          transition: box-shadow 0.2s ease, border-color 0.2s ease;
        }

        .faq-item.open {
          border-color: #db1215;
          box-shadow: 0 4px 20px rgba(0,0,0,0.06);
        }

        .faq-trigger {
          width: 100%;
          background: none;
          border: none;
          padding: 20px 22px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          text-align: left;
          gap: 16px;
        }

        .faq-trigger-text {
          font-family: 'DM Sans', sans-serif;
          font-size: 0.95rem;
          font-weight: 500;
          color: #1a1a1a;
          line-height: 1.4;
          transition: color 0.2s;
        }

        .faq-item.open .faq-trigger-text {
          color: black;
        }

        .faq-icon {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          border: 1.5px solid #d5ccc2;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          transition: background 0.2s, border-color 0.2s, transform 0.3s ease;
          color: #888;
        }

        .faq-item.open .faq-icon {
          background: #db1215;
          border-color: #db1215;
          color: #fff;
          transform: rotate(180deg);
        }

        .faq-body {
          display: grid;
          grid-template-rows: 0fr;
          transition: grid-template-rows 0.35s ease;
        }

        .faq-item.open .faq-body {
          grid-template-rows: 1fr;
        }

        .faq-body-inner {
          overflow: hidden;
        }

        .faq-answer {
          padding: 0 22px 20px;
          font-size: 0.88rem;
          color: #555;
          line-height: 1.7;
          font-weight: 300;
        }

        /* ── FORM ── */
        .cp-form-wrap {
          background: #fff;
          border: 1px solid #e8e4df;
          border-radius: 20px;
          padding: 40px;
          box-shadow: 0 8px 40px rgba(0,0,0,0.05);
        }

        .cp-form-title {
          font-family: 'Fraunces', serif;
          font-size: 2rem;
          font-weight: 600;
          letter-spacing: -0.02em;
          color: #111;
          margin-bottom: 32px;
          line-height: 1.2;
        }

        .cp-field-group {
          display: flex;
          flex-direction: column;
          gap: 6px;
          margin-bottom: 18px;
        }

        .cp-label {
          font-size: 0.82rem;
          font-weight: 500;
          color: #666;
          letter-spacing: 0.02em;
          text-transform: uppercase;
        }

        .cp-input,
        .cp-textarea {
          width: 100%;
          border: 1.5px solid #e0dbd4;
          border-radius: 10px;
          padding: 13px 16px;
          font-family: 'DM Sans', sans-serif;
          font-size: 0.92rem;
          color: #1a1a1a;
          background: #fdfcfb;
          transition: border-color 0.2s, box-shadow 0.2s;
          outline: none;
          resize: none;
        }

        .cp-input:focus,
        .cp-textarea:focus {
          border-color: #db1215;
          box-shadow: 0 0 0 3px rgba(139,105,20,0.08);
          background: #fff;
        }

        .cp-input:disabled,
        .cp-textarea:disabled {
          opacity: 0.55;
          cursor: not-allowed;
        }

        .cp-textarea {
          min-height: 160px;
        }

        .cp-checkbox-row {
          display: flex;
          align-items: flex-start;
          gap: 10px;
          margin-bottom: 20px;
        }

        .cp-checkbox {
          margin-top: 2px;
          width: 17px;
          height: 17px;
          accent-color: #db1215;
          flex-shrink: 0;
          cursor: pointer;
        }

        .cp-checkbox-label {
          font-size: 0.82rem;
          color: #666;
          line-height: 1.5;
        }

        .cp-checkbox-label a {
          color: #db1215;
          text-decoration: underline;
          text-underline-offset: 2px;
        }

        .cp-submit {
          width: 100%;
          padding: 15px;
          background: #1a1a1a;
          color: #fff;
          border: none;
          border-radius: 10px;
          font-family: 'DM Sans', sans-serif;
          font-size: 0.88rem;
          font-weight: 500;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          cursor: pointer;
          transition: background 0.2s, transform 0.15s;
        }

        .cp-submit:hover:not(:disabled) {
          background: #db1215;
        }

        .cp-submit:active:not(:disabled) {
          transform: scale(0.99);
        }

        .cp-submit:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .cp-feedback {
          margin-bottom: 16px;
          padding: 12px 16px;
          border-radius: 9px;
          font-size: 0.87rem;
          font-weight: 500;
          animation: fadeIn 0.25s ease;
        }

        .cp-feedback.ok {
          background: #edfaf2;
          color: #1d7a45;
          border: 1px solid #b3e8cd;
        }

        .cp-feedback.err {
          background: #fff1f1;
          color: #c0392b;
          border: 1px solid #f5c0bb;
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-4px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>

			<div className='cp-root'>
				<div className='cp-inner'>
					<div className='cp-grid'>
						{/* ── FAQ ── */}
						<div>
							<h2 className='' style={{fontSize: 25}}>Întrebări Frecvente</h2>
							<div className='faq-list'>
								{faqs.map((faq, i) => (
									<div key={i} className={`faq-item${openFaq === i ? " open" : ""}`}>
										<button
											className='faq-trigger'
											onClick={() => setOpenFaq(openFaq === i ? -1 : i)}
											aria-expanded={openFaq === i}>
											<span className='faq-trigger-text'>{faq.question}</span>
											<span className='faq-icon'>
												<svg width='12' height='12' viewBox='0 0 12 12' fill='none'>
													<path
														d='M2 4.5L6 8.5L10 4.5'
														stroke='currentColor'
														strokeWidth='1.7'
														strokeLinecap='round'
														strokeLinejoin='round'
													/>
												</svg>
											</span>
										</button>
										<div className='faq-body' role='region'>
											<div className='faq-body-inner'>
												<p className='faq-answer'>{faq.answer}</p>
											</div>
										</div>
									</div>
								))}
							</div>
						</div>

						{/* ── CONTACT FORM ── */}
						<div>
							<div className='cp-form-wrap'>
								<h2 className='' style={{fontSize: 25}}>Contactează-ne pentru Orice Întrebare</h2>

								<form ref={formRef} onSubmit={sendMail} noValidate>
									<div className='cp-field-group'>
										<label className='cp-label' htmlFor='cf-name'>
											Nume
										</label>
										<input
											id='cf-name'
											className='cp-input'
											type='text'
											name='name'
											placeholder='Numele tău'
											maxLength={100}
											disabled={isSubmitting}
											required
										/>
									</div>

									<div className='cp-field-group'>
										<label className='cp-label' htmlFor='cf-email'>
											Adresă de email
										</label>
										<input
											id='cf-email'
											className='cp-input'
											type='email'
											name='email'
											placeholder='email@exemplu.ro'
											maxLength={100}
											disabled={isSubmitting}
											required
										/>
									</div>

									<div className='cp-field-group'>
										<label className='cp-label' htmlFor='cf-message'>
											Mesajul tău
										</label>
										<textarea
											id='cf-message'
											className='cp-textarea'
											name='message'
											placeholder='Scrie mesajul tău aici...'
											maxLength={2000}
											disabled={isSubmitting}
											required
										/>
									</div>

									{showMessage && (
										<div className={`cp-feedback ${success ? "ok" : "err"}`}>
											{success
												? "✓ Mesajul a fost trimis cu succes!"
												: `✕ ${errorMessage || "Oops! Ceva nu a mers bine, te rugăm să reîncerci."}`}
										</div>
									)}

									<div className='cp-checkbox-row'>
										<input
											id='cf-compliance'
											className='cp-checkbox'
											type='checkbox'
											checked={compliance}
											onChange={(e) => setCompliance(e.target.checked)}
										/>
										<label className='cp-checkbox-label' htmlFor='cf-compliance'>
											Sunt de acord cu prelucrarea datelor personale conform{" "}
											<a href='/politica-de-confidentialitate'>
												Politicii de Confidențialitate
											</a>
											.
										</label>
									</div>

									<button type='submit' className='cp-submit' disabled={isSubmitting}>
										{isSubmitting ? "Se trimite..." : "Trimite mesaj"}
									</button>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
